import {FormattedMessage} from "react-intl";
import React, {HTMLAttributes} from "react";

import "./app-footer.scss";

export interface AppFooterDOMProps
    extends Omit<HTMLAttributes<HTMLDivElement>, "children"> {
}

export interface AppFooterProps extends
    AppFooterDOMProps {
  // The light|dark variant that Bootstrap requires to be controlled via html attribute
  variant: "light"|"dark"|string,
  // Footer element reference for accessing variant
  footerRef?: (node: HTMLElement) => void,

}
export default function AppFooter(props: AppFooterProps) {
  const {
    variant,
    footerRef,
    ...other
  } = props

  const year = new Date().getFullYear();
  return (
    <footer
        data-bs-theme={variant}
        ref={footerRef}
        data-test-footer
        id=""
        {...other}
        className={"App-Footer"}
    >
      <p>
        <FormattedMessage
            defaultMessage="Copyright {year} My licenses"
            description="App footer copy. year = four digit year"
            values={{
              year: year,
            }}
        />
      </p>

    </footer>
  );
}
